<template>
  <section class="mt-10" ref="listClientInferieur">
    <div class="level">
      <div class="level-left"></div>
      <div class="level-right">
        <div class="level-item">
          <b-button type="is-primary" @click="gestionDev">
            {{$t('detailClient.ongletEnseiqgnepDV.btnAjoutPDV')}}
          </b-button>
        </div>
      </div>
    </div>
    <b-table
      :data="liste"
      mobile-cards
      paginated
      :per-page="perPage"
      :current-page.sync="currentPage"
      class="no_level">
      
      <template v-for="column in columns">
        <b-table-column
          :key="column.num" v-bind="column"
          header-class="is-size-7 has-text-grid-1 pa-20 has-text-weight-bold"
          cell-class="is-size-7 has-text-default has-text-middle px-20">
          <template
            slot="searchable"
            slot-scope="props">
            <b-select
              v-model="props.filters[column.field]"
              v-if="column.field === 'typologie'"
              :placeholder="$t('general.placeolderSearch')"
              expanded>
              <option value=""> {{$t('general.aucun')}} </option>
              <option
                v-for="(type, i) in typologies"
                :key="i"
                :value="type.value"> {{$t(`detailClient.ongletEnseiqgnepDV.typeClient.${type.libelle}`)}} </option>
            </b-select>
            <b-input
              v-else
              v-model="props.filters[column.field]"
              :placeholder="$t('general.placeolderSearch')"
              icon="magnify"/>
          </template>
          <template v-slot="props">
            <div v-if="column.field === 'nomCommercial' && !column.action">
              <div class="media media-align-center">
                <figure class="media-left">
                  <img height="30" width="30" :src="getImg(props.row.urlLogo)">
                </figure>
                <div class="media-content">
                  {{ props.row.nomCommercial }}
                </div>
              </div>
            </div>
            <div v-else-if="column.action">
              <a @click="actionColumnAction(column.field, props)">
                <b-icon :icon="column.icon" type="is-default"></b-icon>
              </a>
            </div>
            <div v-else>
              {{ props.row[column.field] }}
            </div>
          </template>
        </b-table-column>
      </template>

      <template slot="empty">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>{{$t('tableauDeBord.listeRecom.empty')}}</p>
          </div>
        </section>
      </template>
    </b-table>
    <div class="level" v-if="liste.length">
      <div class="level-left"></div>
      <div class="level-right">
        <div class="level-item is-size-7 has-text-default">
          {{$t('tableauDeBord.listeRecom.libelPerPage')}}
        </div>
        <div class="level-item">
          <b-select placeholder="10" class="is-primary" v-model="perPage">
            <option v-for="value in listePerPageValue" :key="value" :value="value">
              {{value}}
            </option>
          </b-select>
        </div>
        <div class="level-item">
          <b-pagination
            :total="liste.length"
            :current.sync="currentPage"
            order="is-centered"
            :per-page="perPage">
          </b-pagination>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { getClientsInferieur } from '@/api/clients/index';
import { getImg, gestionDev } from '@/services/general/general';
import gestionErreur from '@/services/general/gestionErreur';
import * as config from '@/configuration/clientConf';

export default {
  props: {},
  data() {
    return {
      liste: [],
      perPage: 50,
      currentPage: 1,
      listePerPageValue: [5, 10, 20, 30, 40, 50],
      typologies: config.TYPOLOGIE.filter(el => el.value !== 'Groupe'),
      config,
      isLoad: false,
      columns: [
        {
          field: 'nomCommercial',
          label: this.$t('detailClient.ongletEnseiqgnepDV.table.colonneClient'),
          searchable: true,
        },
        {
          field: 'typologie',
          label: this.$t('detailClient.ongletEnseiqgnepDV.table.colonneType'),
          searchable: true,
        },
        {
          field: 'adresse',
          label: this.$t('detailClient.ongletEnseiqgnepDV.table.colonneAdresse'),
          searchable: true,
        },
        {
          field: 'telephone',
          label: this.$t('detailClient.ongletEnseiqgnepDV.table.colonneTelephone'),
          searchable: true,
        },
        {
          field: 'email',
          label: this.$t('detailClient.ongletEnseiqgnepDV.table.colonneEmail'),
          searchable: true,
        },
        {
          field: 'action',
          label: this.$t('detailClient.ongletEnseiqgnepDV.table.colonneAction'),
          searchable: false,
          numeric: true,
          width: '50',
          icon: 'dots-vertical',
          action: true,
        },
      ]
    }
  },
  methods: {
    getImg(img) {
      return getImg(img);
    },
    gestionDev() {
      return gestionDev();
    },
    async getList() {
      const loadingComponent = this.$buefy.loading.open({ container: this.$refs.listClientInferieur });
      try {
        const liste = [];
        const clientNiveau1 = (await getClientsInferieur(this.$route.params.id)).data;
        clientNiveau1.sort((a, b) => {
          if (a.nomCommercial < b.nomCommercial) return -1;
          if (a.nomCommercial > b.nomCommercial) return 1;
          return 0;
        });
        const reqclientNiveau2 = [];
        clientNiveau1.forEach((client) => {
          reqclientNiveau2.push(getClientsInferieur(client.id))
        });
        const respclientNiveau2 = await Promise.all(reqclientNiveau2);
        if (respclientNiveau2.length) {
          respclientNiveau2.forEach((resp, i) => {
            liste.push(clientNiveau1[i]);
            resp.data.sort((a, b) => {
              if (a.nomCommercial < b.nomCommercial) return -1;
              if (a.nomCommercial > b.nomCommercial) return 1;
              return 0;
            });
            resp.data.forEach((client) => {
              liste.push(client);
            });
          });
        }
        this.liste = liste.flat();
        loadingComponent.close();
      } catch (error) {
        gestionErreur(`Erreur lors de la récupération des clients inferieur au client id: ${this.$route.params.id}`, error);
        loadingComponent.close();
      }
    },
    actionColumnAction(column/* , props */) {
      if(column === 'action') this.gestionDev()
    }
  },
  async mounted() {
    await this.getList();
  },
};
</script>

<style lang="scss" scoped>
</style>
